import { render, staticRenderFns } from "./PartnerRoute.vue?vue&type=template&id=0a011903&scoped=true&"
import script from "./PartnerRoute.vue?vue&type=script&lang=js&"
export * from "./PartnerRoute.vue?vue&type=script&lang=js&"
import style0 from "./PartnerRoute.vue?vue&type=style&index=0&id=0a011903&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a011903",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VChip,VContainer,VDataTable,VIcon})
